import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Operations',
  icon: 'mdi-clipboard-text-outline',
  path: '/reports/shift',
  menuFilters: {
    $and: [
      { countryCode: { $in: ['za'] } },
      { enterpriseClient: { $eq: 'McDonalds' } },
    ],
  },
  children: [
    {
      path: '/reports/shift/dailyActivity',
      name: 'Daily Activity Report',
      meta: { id: 'mc-dailyActivity', permission: 'mtDailyActivity' },
      component: () => import('./DailyActivityReport.vue'),
      ...addPermissionsToRoute(['mtDailyActivity']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    },
    {
      path: '/reports/shift/opsReport',
      name: 'Operations Report',
      meta: { id: 'mc-opsReport', permission: 'mtShift' },
      component: () => import('./opsReport/OpsReportWrapper.vue'),
      ...addPermissionsToRoute(['mtShift']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    },
  ],
};

export default routes;
